import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';
import { Button, CircularProgress } from '@mui/material';

const ManageSessions = () => {
  const { accessToken } = useAuth();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSessionId, setCurrentSessionId] = useState(null);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const res = await axiosInstance.get('/auth/sessions', {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        setSessions(res.data.sessions || []);
        const sessionId = document.cookie.split('; ').find(row => row.startsWith('sessionId='))
          ?.split('=')[1];
        setCurrentSessionId(sessionId);
      } catch (err) {
        console.error('Failed to fetch sessions', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, [accessToken]);

  const handleRevoke = async (sessionId) => {
    try {
      await axiosInstance.delete(`/auth/sessions/${sessionId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setSessions(prev => prev.filter(session => session.session_id !== sessionId));
    } catch (err) {
      console.error('Failed to revoke session', err);
      alert('Failed to revoke session.');
    }
  };

  if (loading) {
    return <div className="loading-container"><CircularProgress /></div>;
  }

  return (
    <div className="container" style={{ padding: '1rem' }}>
      <h2>Active Sessions</h2>
      {sessions.length === 0 ? (
        <p>No active sessions found.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <Button
            variant="contained"
            color="error"
            onClick={async () => {
                if (!window.confirm('Are you sure you want to revoke all other sessions?')) return;
                try {
                await axiosInstance.delete('/auth/session/revoke-all', {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                setSessions(prev => prev.filter(s => s.session_id === currentSessionId));
                } catch (err) {
                console.error('Failed to revoke all sessions', err);
                alert('Could not revoke all sessions.');
                }
            }}
            >
            Revoke All Other Sessions
            </Button>

          {sessions.map(session => (
            <li key={session.session_id} style={{ marginBottom: '1rem', borderBottom: '1px solid #ccc', paddingBottom: '1rem' }}>
              <p><strong>Device:</strong> {session.user_agent}</p>
              <p><strong>IP:</strong> {session.ip_address}</p>
              <p><strong>Trusted:</strong> {session.is_trusted_device ? 'Yes' : 'No'}</p>
              <p><strong>Persistent:</strong> {session.is_persistent ? 'Yes' : 'No'}</p>
              <p><strong>Last used:</strong> {new Date(session.last_used_at || session.expires_at).toLocaleString()}</p>
              {session.session_id !== currentSessionId ? (
                <Button variant="outlined" color="error" onClick={() => handleRevoke(session.session_id)}>
                  Revoke
                </Button>
              ) : (
                <p style={{ color: 'green' }}>(This device)</p>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ManageSessions;
